import { createFileRoute } from "@tanstack/react-router";
import { SchemaEditor } from "@/pages/3d/configuration/SchemaEditor";

export const Route = createFileRoute("/demo/3d/configuration/schema-editor")({
  component: SchemaEditor,
});
